import React, { useMemo } from "react";
import { Route, Routes, useLocation, Outlet } from "react-router-dom";
import useLayouts from "../../layouts";
import useControllers from "../../../controllers";

// Views
import RolesView from "./Views";
import RolesCreate from "./Create";
import RolesEdit from "./Edit";

const RolesLayout = () => {
  const { PrivateContentLayout } = useLayouts();
  const location = useLocation();
  const { useRoles } = useControllers().useScreenHooks();
  const { handleBack, header } = useRoles();

  const pathWithOutId = useMemo(() => {
    const pathArray = location.pathname.split("/");
    const filterArray = pathArray.filter((path) => isNaN(path));
    return filterArray.join("/");
  }, [location.pathname]);

  return (
    <PrivateContentLayout
      breadcrumbsList={
        location.pathname.split("/").length > 2
          ? header[Object.keys(header).filter((header) => location.pathname.includes(header))[1]]
          : header[Object.keys(header).filter((header) => location.pathname.includes(header))]
      }
      handleBack={handleBack}
      showBack={location.pathname !== "/roles"}
      title="Roles"
    >
      <Outlet />
    </PrivateContentLayout>
  );
};

const Roles = () => {
  return (
    <Routes>
      <Route path="/" element={<RolesLayout />}>
        <Route index element={<RolesView />} />
        <Route path="creacion" element={<RolesCreate />} />
        <Route path="editar/:id" element={<RolesEdit />} />
      </Route>
    </Routes>
  );
};

export default Roles;
